<template>
  <div class="payment-total-row">
    <div
      v-for="transaction in data.transactionItems"
      :key="transaction.idTransactionItemInt"
    >
      {{ transaction.total | currencyTruncate }}
    </div>
    <hr>
    <div>
      {{ total | currencyTruncate }}
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "payment-total-row",
  props: {
    data: { type: Object },
  },
  computed: {
    total() {
      return this.data.transactionItems.reduce(
        (a, b) => a + parseFloat(b.total, 10),
        0
      );
    },
  },
};
</script>
  
  <style>
.payment-total-row {
  padding-top: 7px;
}
</style>